import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
// import { AuthContext } from './AuthContext';
import { useSelector } from 'react-redux';
import { makeSelectIsAuthenticated,makeSelectToken,makeSelectUser } from "../containers/App/selectors";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
//   const { user, isAuthenticated } = useContext(AuthContext);
  // Get authentication state from Redux
  const isAuthenticated = useSelector(makeSelectIsAuthenticated());
  const token = useSelector(makeSelectToken());
  const user = useSelector(makeSelectUser());


  const socketRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  
  // Initialize socket connection
  useEffect(() => {
    if (isAuthenticated && token && user?.id && !socketRef.current) {
      const cleanedToken = token.startsWith('Bearer ') ? token.split(' ')[1] : token;
    console.log('Cleaned token:', cleanedToken); // Log to verify

      const socket = io(process.env.REACT_APP_API_BASE_URL, {
        withCredentials: true,
        transports: ['websocket', 'polling'],
        auth: {
          token: cleanedToken
        },
         reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        timeout: 10000 // Add explicit timeout
      });
      
      socketRef.current = socket;
      

    // In SocketProvider.js
    socket.on('connect', () => {
      const roomId = user.id.toString();
      console.log('[CLIENT] Emitting join-user for room:', roomId);
      socket.emit('join-user', roomId, (response) => {
        console.log('[CLIENT] Join acknowledgement:', response);
      });

      // Join admin room if user is admin
          if (user.isAdmin) {
            socket.emit('join-admin');
            console.log('Admin joined admin room');
          }
    });
      
      // In SocketProvider.js
    socket.on('new-notification', (notification) => {
      console.log('Received new notification:', notification);
      setNotifications(prev => [notification, ...prev]);
      // Fix unread count logic:
      setUnreadCount(prev => notification.read ? prev : prev + 1);
    });

     socket.on('admin-notification', (notification) => {
      // Admin-specific notifications
      if (user.isAdmin) {
        console.log('Received admin notification:', notification);
        setNotifications(prev => [notification, ...prev]);
        setUnreadCount(prev => prev + 1);
      }
    });
      
      
      socket.on('disconnect', () => {
        console.log('Socket disconnected');
      });
      
      socket.on('connect_error', (err) => {
        console.error('Socket connection error:', err.message);
      });
    }
    
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [isAuthenticated,token, user?.id]);


// Handle token refresh
  useEffect(() => {
    if (socketRef.current && isAuthenticated && token && user?.id) {
      const cleanedToken = token.startsWith('Bearer ') ? token.split(' ')[1] : token;
      if (socketRef.current.auth.token !== cleanedToken) {
        console.log('Updating socket token');
        socketRef.current.auth.token = cleanedToken;
        socketRef.current.disconnect().connect();
        socketRef.current.once('connect', () => {
          console.log('Reconnected with new token');
          socketRef.current.emit('join-user', user.id);
        });
      }
    }
  }, [token, user?.id]);




  
  // Reconnect on token refresh
  // useEffect(() => {
  //   if (socketRef.current && isAuthenticated) {
  //     socketRef.current.auth.token = user.token;
  //     socketRef.current.disconnect().connect();
  //   }
  // }, [user.token]);
  //   useEffect(() => {
  //   if (socketRef.current && isAuthenticated && token && user.id) {
  //     // Update token and reconnect
  //     socketRef.current.auth.token = token;
  //     console.log('popop')
  //     socketRef.current.disconnect().connect();
  //     // socketRef.current.connect();
      
  //     // Re-join user room after reconnect
  //     socketRef.current.once('connect', () => {
  //     console.log('popop22')

  //       socketRef.current.emit('join-user', user.id);
  //     });
  //   }
  // }, [token, user.id]);
  
  // Mark notification as read
  const markAsRead = (id) => {
    setNotifications(prev => 
      prev.map(notif => 
        notif._id === id ? { ...notif, read: true } : notif
      )
    );
    setUnreadCount(prev => Math.max(0, prev - 1));
  };
  
  // Clear all notifications
  const markAllAsRead = () => {
    setNotifications([]);
    setUnreadCount(0);
  };
  
  const value = {
    socket: socketRef.current,
    notifications,
    unreadCount,
    markAsRead,
    markAllAsRead
  };
  
  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);